<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="检测项知识库" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey" keyName="name">
      <router-link to="/detection-corpus-new" slot="before-left"><el-button type="primary">新建检测项知识库</el-button></router-link>
    </pt-page-title>
    <!-- 筛选 -->
    <pt-page-factor-filter :labels="filterLabels" v-model="filterForm" isQueryRouter ref="filter" @Filter="handleFilter">
      <div>
          <el-button type="primary" @click="handleFilter(false)">筛选</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </div>
    </pt-page-factor-filter>
    <!-- 表格 -->
    <pt-detection-corpus-table :tableLabels="currentTableLabels" ref="table" :paramsData="paramsData" :isFromRouter="isFromRouter">
      <template slot-scope="scope">
        <i class="iconfont icon-xiangqing pointer" @click="goDetail(scope.row)"></i>
        <i class="iconfont icon-bianji pointer" @click="goEdit(scope.row.id, scope.row)"></i>
        <i class="iconfont icon-shanchu pointer" @click="goDelete(scope.row)"></i>
      </template>
    </pt-detection-corpus-table>
  </div>
</template>

<script>
import ptDetectionCorpusTable from './pt-detection-corpus-table/withData'
import { filterFactor, tableLabels } from './detection-corpus-options.js'
import { emptyObject } from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-detection-corpus-list'

export default {
  name: 'pt-detection-corpus-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      return tableLabels
    }
  },
  components: {
    ptDetectionCorpusTable
  },
  data () {
    return {
      filterLabels: filterFactor,
      filterForm: {},
      loading: false,
      paramsData: {},
      isFromRouter: false,
      searchKey: ''
    }
  },
  methods: {
    cleanParams () {
      emptyObject(this.filterForm)
      this.handleFilter(false)
    },
    handleFilter (isFromRouter) {
      this.isFromRouter = isFromRouter

      // 筛选时不考虑关键字的问题
      if (!isFromRouter) {
        this.searchKey = null
        if (this.filterForm.name) {
          this.$delete(this.filterForm, 'name')
        }
      }
      for (var key in this.filterForm) {
        if (!this.filterForm[key]) {
          this.$delete(this.filterForm, key)
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.filterForm))
      this.$nextTick(_ => {
        if (!this.isFromRouter) {
          this.$refs.filter.getAddRouter(this.paramsData)
        }
      })
      // this.$refs.table.reload(this.filterForm)
    },
    search (key) {
      this.searchKey = key
      emptyObject(this.filterForm)
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'name', key)
    },
    emptySearch () {
      this.$delete(this.paramsData, 'name')
    },
    goDetail (data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-corpus-detail', params: { id: data.id, value: data } })
    },
    goEdit (id) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-corpus-update', params: { id: id } })
    },
    goDelete (data) {
      this.$confirm('确定要删除检测项：' + data.chineseName + '的知识库?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteDetectionCorpus', data.id).then(res => {
          this.$refs.table.reload()
          this.$message.success('成功删除了检测项：' + data.chineseName + '的知识库!')
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
